import type { HandlingUnit } from "~/shared/types/quote-details-types";

export const getEstClass = (density: number) => {
	const densityClassMap = [
		{ min: 50, value: 50 },
		{ min: 35, value: 55 },
		{ min: 30, value: 60 },
		{ min: 22.5, value: 65 },
		{ min: 15, value: 70 },
		{ min: 12, value: 85 },
		{ min: 10, value: 92.5 },
		{ min: 8, value: 100 },
		{ min: 6, value: 125 },
		{ min: 4, value: 175 },
		{ min: 2, value: 250 },
		{ min: 1, value: 300 },
		{ min: 0, value: 400 },
	];
	if (density === 0) {
		return 0;
	} else {
		for (const { min, value } of densityClassMap) {
			if (density >= min) {
				return value;
			}
		}
	}
	return 0;
};

export const calculateItemDensity = (
	item: Pick<
		HandlingUnit,
		"quantity" | "weight" | "length" | "width" | "height"
	>,
	measuringType = "LB/IN",
) => {
	let density = 0;
	const { quantity, weight, length, width, height } = item;

	let convertedWeight = weight;
	let convertedLength = length;
	let convertedWidth = width;
	let convertedHeight = height;

	const hasAllDimensions =
		(quantity ?? 0) > 0 &&
		(weight ?? 0) > 0 &&
		(width ?? 0) > 0 &&
		(height ?? 0) > 0 &&
		(length ?? 0) > 0;

	if (measuringType === "KG/CM") {
		convertedWeight = Math.ceil((convertedWeight ?? 0) * 2.204_622_621_85);
		// Convert dimensions from centimeters to inches
		convertedLength = (convertedLength ?? 0) * 0.393_701;
		convertedWidth = (convertedWidth ?? 0) * 0.393_701;
		convertedHeight = (convertedHeight ?? 0) * 0.393_701;
	}

	if (hasAllDimensions) {
		const cubicInches =
			(convertedWidth ?? 0) * (convertedHeight ?? 0) * (convertedLength ?? 0);
		const cubicFeet = cubicInches / 1728;
		// Calculate density as total weight divided by total volume
		// total volume = unit volume * quantity
		density =
			cubicFeet > 0
				? (convertedWeight ?? 0) / (cubicFeet * (quantity ?? 1))
				: 0;
	}

	return density;
};
